import React from 'react';
import { DiscordIcon } from 'icons/discord';
import { InstagramIcon } from 'icons/instagram';
import { OpenSeaIcon } from 'icons/opensea';
import { TikTokIcon } from 'icons/tiktok';
import { TwitchIcon } from 'icons/twitch';
import { TwitterIcon } from 'icons/twitter';
import { YoutubeIcon } from 'icons/youtube';
import { externalRoutes } from 'routing/externalRoutes';
import cls from 'classnames';

import styles from './Socials.module.scss';

type SocialProps = {
  showNames?: boolean;
  className?: string;
};

export const Socials = ({ showNames, className }: SocialProps) => {
  return (
    <div className={cls(styles.socials, className)}>
      <a
        href={externalRoutes.discord()}
        target="_blank"
        rel="noreferrer"
        className={styles.socialName}
      >
        <DiscordIcon />
        {showNames && <span>Discord</span>}
      </a>
      <a
        href={externalRoutes.twitter()}
        target="_blank"
        rel="noreferrer"
        className={styles.socialName}
      >
        <TwitterIcon stroke={styles.iconColor} />
        {showNames && <span>Twitter</span>}
      </a>
      <a
        href={externalRoutes.openSea()}
        target="_blank"
        rel="noreferrer"
        className={styles.socialName}
      >
        <OpenSeaIcon stroke={styles.iconColor} />
        {showNames && <span>OpenSea</span>}
      </a>
      <a
        href={externalRoutes.instagram()}
        target="_blank"
        rel="noreferrer"
        className={styles.socialName}
      >
        <InstagramIcon />
        {showNames && <span>Instagram</span>}
      </a>
      <a
        href={externalRoutes.youtube()}
        target="_blank"
        rel="noreferrer"
        className={styles.socialName}
      >
        <YoutubeIcon />
        {showNames && <span>Youtube</span>}
      </a>
      <a
        href={externalRoutes.twitch()}
        target="_blank"
        rel="noreferrer"
        className={styles.socialName}
      >
        <TwitchIcon />
        {showNames && <span>Twitch</span>}
      </a>
      <a
        href={externalRoutes.tiktok()}
        target="_blank"
        rel="noreferrer"
        className={styles.socialName}
      >
        <TikTokIcon />
        {showNames && <span>TikTok</span>}
      </a>
    </div>
  );
};
